import { useState } from 'react'
import { useNavigate } from 'react-router'
import { createClient } from '@/api-client'
import { Account } from '@/api-client/Account'
import { BranchPageHeading } from '@/components/subscription/branch-page-heading'

export const SubscriptionRoseMypageEmail: React.FC = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const inputClass = 'w-full border border-gray rounded-lg px-3 py-3 text-[14px] outline-none focus:border-black transition-colors bg-white'

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault()

    const form = e.currentTarget
    if (!form.checkValidity()) {
      form.reportValidity()
      return
    }

    setIsSubmitting(true)
    setMessage('')

    try {
      await createClient(Account).putAccount({ new_email: email, password })

      await navigate('/subscription/rose/mypage', { state: { message: 'メールアドレスを変更しました' } })
    } catch (error) {
      setMessage(error.response?.data?.error?.message_displayable || 'メールアドレスの変更に失敗しました')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="w-full space-y-8 pt-4 pb-18">
      <BranchPageHeading main="メールアドレス変更" className="mb-8" />

      {message && (
        <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-3 mb-6 flex items-start gap-2">
          <svg className="w-4 h-4 mt-0.5 shrink-0 text-red-500" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.3" />
            <path d="M8 5v3.5M8 11h.01" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
          </svg>
          <p className="text-[13px] text-red-600 flex-1">{message}</p>
          <button onClick={() => setMessage('')} className="text-red-400 hover:text-red-600 transition-colors text-[14px] leading-none">
            ×
          </button>
        </div>
      )}

      <form onSubmit={handleSubmit} noValidate>
        <section className="bg-white rounded-2xl p-6 mb-6">
          <div className="space-y-5">
            <div>
              <label htmlFor="email" className="block text-[12px] text-dark-gray mb-2">
                新しいメールアドレス <span className="text-accent">*</span>
              </label>
              <input
                id="email"
                type="email"
                inputMode="email"
                autoComplete="new-email"
                placeholder="example@email.com"
                className={inputClass}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-[12px] text-dark-gray mb-2">
                現在のパスワード <span className="text-accent">*</span>
              </label>
              <div className="relative">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="current-password"
                  placeholder="パスワード"
                  className={inputClass + ' pr-10'}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-dark-gray hover:text-black transition-colors"
                  aria-label={showPassword ? 'パスワードを隠す' : 'パスワードを表示'}
                >
                  {showPassword ? (
                    <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2 2l12 12M6.5 6.55A2 2 0 0 0 9.45 9.5M4.19 4.22C2.82 5.13 1.73 6.46 1 8c1.33 2.93 4 5 7 5a7.2 7.2 0 0 0 3.81-1.08M6.8 3.1A7.4 7.4 0 0 1 8 3c3 0 5.67 2.07 7 5a8.5 8.5 0 0 1-1.72 2.56"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <ellipse cx="8" cy="8" rx="7" ry="4.5" stroke="currentColor" strokeWidth="1.2" />
                      <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.2" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>
        </section>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full h-14 bg-black text-white text-[15px] font-medium rounded-xl hover:bg-black/80 disabled:bg-black/80 transition-colors cursor-pointer"
        >
          変更する
        </button>
      </form>
    </div>
  )
}
